import requestOptions from "./RequestOptions";
import GeneralMapper from "../models/General_Mapper";
import AuthMapper from "../models/Auth_Mapper";
import General from "../util/General";
import urlServices from "../../environments/API";
const urlSeguridades = urlServices.seguridad;
const urlSeguridadesExt = urlServices.seguridadExt;
const urlConfiguracion = urlServices.configuracion;

const loginService = async (credentials) => {
  let response;
  try {
    const encodedCredentials = await General.base64Encode(
      `${credentials.user}:${credentials.password}`
    );
    const token = `Basic ${encodedCredentials}`;
    const options = requestOptions.options("POST", token, "");
    const resp = await fetch(urlSeguridades + global.LOGIN, options);
    const data = await resp.json();
    if (data.success && data.code === global.SUCCESS_CODE) {
      response = AuthMapper.loginMapper(data);
    } else {
      response = GeneralMapper.responseMapper(data);
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error);
  }
  return response;
};

const loginServiceUserExt = async (credentials) => {
  let response;
  try {
    const encodedCredentials = await General.base64Encode(
      `${credentials.user}:${credentials.password}`
    );
    const token = `Basic ${encodedCredentials}`;
    const options = requestOptions.optionsLogExt("POST", token, "");
    const resp = await fetch(urlSeguridadesExt + global.LOGINEXT, options);
    const data = await resp.json();
    if (data.success && data.code === global.SUCCESS_CODE && data.data.statusCode == null ) {
      response = AuthMapper.loginMapperUserEx(data);
    } else {
      response = GeneralMapper.responseMapper(data);
    }
  } catch (error) {
    response = GeneralMapper.catchMapper(error);
  }
  return response;
};

const refreshTokenService = async () => {
  let response;
  try {
    const daraToSave = {
      refreshToken: localStorage.getItem("refreshToken"),
    };
    const token = `Bearer ${localStorage.getItem("token")}`;
    const options = requestOptions.options("POST", token, daraToSave);
    const resp = await fetch(urlSeguridades + global.REFRESH_TOKEN, options);
    const data = await resp.json();
    if (data.success && data.code === global.SUCCESS_CODE) {
      localStorage.setItem("token", data.data.idToken);
    }
    response = data;
  } catch (error) {
    response = GeneralMapper.catchMapper(error);
  }
  return response;
};

const SaveLogService = async (dataLog) => {
  let response;
  try {
    const token = `Bearer ${localStorage.getItem("token")}`;
    const options = requestOptions.optionsConfig("POST", token, dataLog);
    const resp = await fetch(urlConfiguracion + global.SAVE_LOGS, options);
    const data = await resp.json();
    if (data.success && data.code === global.SUCCESS_CODE) {
    }
    response = data;
  } catch (error) {
    response = GeneralMapper.catchMapper(error);
  }
  return response;
};

const callApiAIService = async (request) => {
  let response1;
  /*try {
    const token = `Bearer dXBgF3@2$4^7A*sl+F&vT7yMg!QzR9qL8%nDd6wL3H5eK8jPl`
    const options = requestOptions.optionsConfig('POST', token, request)
    const resp = await fetch(global.GET_AI_ANSWER, options)
    const data = await resp.json()
    if (data.success && data.code === global.SUCCESS_CODE) {
      
    }
    response = data
  } catch (error) {
    response = GeneralMapper.catchMapper(error)
  }*/
  const url = "https://api-phantomx.veris.com.ec/ia/v1/aier/preguntar";
  //const url = "http://ws.demoelcorp.me/ia/v1/aier/preguntar";
  const token = "dXBgF3@2$4^7A*sl+F&vT7yMg!QzR9qL8%nDd6wL3H5eK8jPl";

  const data = {
    pregunta: request,
    sessionId: "session123",
  };
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `BEARER ${token}`,
      },
      body: JSON.stringify(request),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const responseData = await response.json();
    response1 = responseData
    //response1 = JSON.stringify(responseData, null, 2);
  } catch (err) {
    response1 = "";
  }
  return response1;
};

const authServices = {
  loginService,
  loginServiceUserExt,
  refreshTokenService,
  SaveLogService,
  callApiAIService,
};

export default authServices;
